import type { AnchorHTMLAttributes, FC } from 'react'
import { type ButtonProps, Button as MuiButton } from '@mui/material'

type Props =
    & Omit<ButtonProps, 'color' | 'variant'>
    & Readonly<{ variant: NonNullable<ButtonProps['variant']> }>
    & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target'>

/**
 * `Button` is just a wrapper for MuiButton that:
 * - deprecates usage of `color` prop
 * - makes `variant` prop mandatory
 */
export const Button: FC<Props> = MuiButton
